import { jsx } from 'panel';
import { DataTableEl } from 'common/components/data-table';
import { Theme as DataTableTheme } from 'common/components/data-table/types';
import { propagateEvent } from 'common/util/dom';
import { getDataTableColumnGroups, getDataTableRows } from './utils';
export function template() {
  return jsx("div", {
    sel: '.trend-data-table'
  }, jsx(DataTableEl, {
    attrs: {
      // TODO(mack): Persist sort order and pass it to mp-data-table
      'multi-select': true,
      'selection-limit': this.attr("selection-limit"),
      'default-sorting': this.attr("default-sorting"),
      'has-comparison': false,
      'segmentation-data-table': true,
      'sticky-columns-count': 2,
      'track-name': this.attr("track-name"),
      theme: DataTableTheme.TrendData
    },
    props: {
      rows: getDataTableRows(this.rows),
      columnGroups: getDataTableColumnGroups({
        segments: this.segments,
        rows: this.rows,
        trendUnit: this.attr("trend-unit"),
        valueFormatter: this.valueFormatter
      })
    },
    on: {
      selectionChange: ev => propagateEvent(this, ev),
      sortChange: ev => propagateEvent(this, ev)
    }
  }));
}